import { Stack, Typography } from "@mui/material";
import { Handle, Position } from "@xyflow/react";

import type { ClearReactionRuleNode, RuleNodeProps } from "../types/nodes";
import BaseNode from "./BaseNode";

type ClearReactionNodeProps = RuleNodeProps<ClearReactionRuleNode>;

const ClearReactionNode = (props: ClearReactionNodeProps) => {
	const { data } = props;
	const reactionName = data.reactionNodeName;

	return (
		<BaseNode {...props}>
			{reactionName ? (
				<Stack direction="row" spacing={0.5} alignItems="baseline" flexWrap="wrap">
					<Typography variant="body2" color="text.secondary" fontWeight={600}>
            Clears:
					</Typography>
					<Typography variant="body2" color="text.primary">
						{reactionName}
					</Typography>
				</Stack>
			) : (
				<Typography variant="body2" color="text.disabled">
          No reaction selected
				</Typography>
			)}
			<Handle type="target" position={Position.Top} id="in" />
		</BaseNode>
	);
};

export default ClearReactionNode;
